export default {
  CREATING: 'ADMIN_VIEW_MARKET_CREATOR_CREATING',
  CREATED: 'ADMIN_VIEW_MARKET_CREATOR_CREATED',
};
